export function formatBaht(cents: number): string {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function parseBaht(value: FormDataEntryValue | null): number {
  const raw = String(value ?? "").replace(/[^\d.]/g, "");
  const parsed = Number(raw || 0);
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return Math.round(parsed * 100);
}

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat("th-TH", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function compactUserAgent(userAgent: string): string {
  if (!userAgent) return "ไม่พบ user agent";
  return userAgent.replace(/\s+/g, " ").slice(0, 96);
}
